import { useMutation } from "@/compat/reactQuery";
import brandingService from "../../services/brandingService";

const useSaveBranding = () => useMutation(brandingService.saveBranding);

export default useSaveBranding;
